import { getCategories } from "@/services/category";
import { useEffect, useState } from "react";

interface ICategory {
  id: number,
  title: string,
  icon: string,
  color: string,
  createdAt: string,
}

const useFetch = () => {
  const size = 10;
  const offset = 0;
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<ICategory[]>([]);
  
  const handleGetCategory = async () => {
    setLoading(true);
    const res = await getCategories(size, offset);
    if (res.data.items) {
      setList(res.data.items);
    }
    setLoading(false);
  }

  useEffect(() => {
    handleGetCategory();
  }, []);

  return { loading, list }
}

export default useFetch;